import React from 'react';
import { IconSvgProps } from '@models/common';

const NavHumanizer: React.FC<IconSvgProps> = (props) => {
  const { size = 24, strokeWidth = 2, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.66725 4H4V6.66643M17.3327 4H20V6.66643M6.66725 20H4V17.3336M17.3327 20H20V17.3336M7.55516 16.4446C7.55516 13.9902 9.54545 12.0005 12.0006 12.0005C14.4557 12.0005 16.446 13.9902 16.446 16.4446H7.55516ZM12 11.9995C13.4731 11.9995 14.6673 10.8057 14.6673 9.33304C14.6673 7.86041 13.4731 6.66661 12 6.66661C10.5269 6.66661 9.33274 7.86041 9.33274 9.33304C9.33274 10.8057 10.5269 11.9995 12 11.9995Z'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default NavHumanizer;
